import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/comics";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-background-900 border-t hairline">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg flex items-center justify-center bg-gradient-to-br from-primary-500 to-secondary-600 text-background-50">
                <i className="ri-book-open-line text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-lg text-foreground-50">禁漫天堂</span>
                <span className="text-[10px] tracking-[0.28em] text-foreground-400 font-label mt-1">MANGA HAVEN</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-400">
              禁漫天堂是一个面向动漫漫画爱好者的资源聚合站点，汇集热血、恋爱、奇幻、悬疑等多类别作品，提供作品详情、章节目录与资源索引，帮助你在最短时间内找到想读的那一本。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-qq-line", "ri-telegram-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md flex items-center justify-center bg-background-800 text-foreground-300 border hairline"
                  aria-hidden="true"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-sm font-medium text-foreground-100 mb-4">热门分类</h2>
            <ul className="space-y-2.5">
              {CATEGORIES.slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-foreground-400 hover:text-accent-300 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-medium text-foreground-100 mb-4">站点导航</h2>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors">网站首页</Link></li>
              <li><Link to="/category/hot-blood" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors">全部分类</Link></li>
              <li><Link to="/search" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors">漫画搜索</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors">关于我们</Link></li>
              <li><Link to="/about#faq" className="text-sm text-foreground-400 hover:text-accent-300 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-medium text-foreground-100 mb-4">联系我们</h2>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                support@jinman-haven.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400" />
                客服值班 09:00 - 23:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" />
                线上运营团队 · 远程协作
              </li>
            </ul>
            <div className="mt-4 rounded-lg border hairline bg-background-800/60 px-3 py-2.5">
              <p className="text-[11px] leading-5 text-foreground-500">
                本站所有资源仅用于页面演示，不提供真实文件分发。请支持正版作品的合法购买与阅读。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t hairline flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 禁漫天堂 MANGA HAVEN. 内容仅作演示，版权归原作者所有。
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <span className="whitespace-nowrap">免责声明</span>
            <span className="whitespace-nowrap">隐私政策</span>
            <span className="whitespace-nowrap">版权投诉</span>
            <span className="whitespace-nowrap">站点地图</span>
          </div>
        </div>
      </div>
    </footer>
  );
}